import "./src/styles/app.scss"

export const onPreRouteUpdate = ({ location, prevLocation }) => {
  const BODY_LOCK = "util__body-lock"

  if (document.body.classList.contains(BODY_LOCK)) {
    document.body.classList.remove(BODY_LOCK)
  }
}